<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="$t('nextengine.nextengine_ec-receiveorder-register-title')"
      :isFooter="true"
      :width="width"
      isCardColor="true"
    >
      <v-container class="pa-4">
        <v-card class="mb-4" outlined>
          <v-card-title class="section-title">
            販売登録情報
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-up</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <InputFormNew
                  :value="inputData"
                  :detail="formItems"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                </InputFormNew>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined>
          <v-card-title class="section-title">
            販売登録するEC販売履歴選択
            <v-spacer></v-spacer>
            <v-icon>mdi-chevron-up</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <div class="order-detail-table">
              <v-data-table
                v-model="selectedEcReceiveOrderIds"
                :headers="ecReceiveorderHeaders"
                :items="processedEcReceiveorderLists"
                item-key="ecReceiveOrderId"
                :items-per-page="-1"
                show-select
                hide-default-footer
                class="elevation-0"
              >
              <template #item.detail="{ item }">
                  <v-layout>
                    <WhiteButton
                      text="common.common_detail"
                      height="32px"
                      width="32px"
                      class="mx-1"
                      @click="detail(item)"
                    />
                  </v-layout>
                </template>
                <template #item.productName="{ item }">
                  <div style="white-space: pre-wrap;">{{ item.productName }}</div>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
      <template v-slot:footer>
        <v-spacer></v-spacer>
        <WhiteButton
          :text="$t('common.common_back')"
          height="50px"
          width="130px"
          @click="closeDialog"
          class="mr-2"
        />
        <NormalButton
          :text="$t('common.common_register')"
          height="50px"
          width="130px"
          @click="register"
        />
      </template>
    </DialogBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { i18n } from '@/main.js'
import { WhiteButton, NormalButton } from '@/components/items'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    DialogBase,
    WhiteButton,
    NormalButton,
    InputFormNew,
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    ecReceiveorderLists: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    errDialog: false,
    inputData: {
      customer: {
        label: '',
        value: null,
        neShopId: null,
        autoShipStorageId: null
      },
      currency: {
        label: '',
        value: null
      },
      autoShipFlg: false
    },
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 7,
      inputItemHeight: '32px'
    },
    selectedEcReceiveOrderIds: [],
    ecReceiveorderHeaders: [
      {text: '伝票番号', value: 'receiveOrderId', sortable: false, align: 'start', width: '10%'},
      {text: '受注日', value: 'receiveOrderDate', sortable: false, align: 'start', width: '10%'},
      {text: '受注番号', value: 'receiveOrderShopCutFormId', sortable: false, align: 'start', width: '10%'},
      {text: '店舗', value: 'receiveOrderShopName', sortable: false, align: 'start', width: '10%'},
      {text: '購入者名', value: 'receiveOrderPurchaserName', sortable: false, align: 'start', width: '10%'},
      {text: '合計金額', value: 'receiveOrderTotalAmount', sortable: false, align: 'end', width: '10%'},
      {text: '送り先名', value: 'receiveOrderConsigneeName', sortable: false, align: 'end', width: '10%'},
      {text: '発送方法', value: 'receiveOrderDeliveryName', sortable: false, align: 'end', width: '10%'},
      {text: '詳細', value: 'detail', sortable: false, align: 'end', width: '5%'},
      {text: 'EC商品連携', value: 'linkedStatusText', sortable: false, align: 'center', width: '10%'},
    ]
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Nextengine', [
      'registerSaleFromEcReceiveorderFromApi',
    ]),
    ...mapActions('Common', ['setIsLoading']),
    ...mapGetters('User', ['getUserInfoFromState']),
    async init() {
      // 通貨選択の初期値
      const user = this.getUserInfoFromState()
      this.inputData.currency.value = user.organization.currencyId
    },
    async detail(ecReceiveorderData) {
      const detailData = await _cloneDeep(ecReceiveorderData)
      this.$emit('detail', detailData)
    },
    async register() {
      // 各種バリデーションチェック
      const isPendingExists = this.selectedEcReceiveOrderIds.some(
        (order) => order.saleStatus === 3
      )
      if (isPendingExists) {
        alert(
          '選択された受注伝票にステータス更新待ちのものが含まれています。\nしばらく時間をおいて一覧を更新してから再度お試しください。'
        )
        return
      }
      if (!this.inputData.customer.value || !this.inputData.currency.value) {
        alert('顧客と通貨は必須です。')
        return
      }
      if (this.selectedEcReceiveOrderIds.length === 0) {
        alert('受注伝票を選択してください。')
        return
      }
      if (this.selectedEcReceiveOrderIds.length > 100) {
        alert(
          '受注伝票選択が100件を超えています。\n条件を調整して再度お試しください。'
        )
        return
      }
      if (this.inputData.customer.neShopId === null) {
        alert('ネクストエンジン連携から取り込んだ店舗顧客を選択してください。')
        return
      }
      if (
        this.inputData.autoShipFlg &&
        this.inputData.customer.autoShipStorageId === null
      ) {
        alert('自動出庫対象の倉庫が設定されていない顧客です。')
        return
      }
      // EC商品連携状態のチェック
      // 選択された伝票から未連携のEC商品番号を収集
      const unlinkedProductNumbers = []
      this.selectedEcReceiveOrderIds.forEach(order => {
        if (!order.isFullyLinked) {
          order.ecReceiveOrderRows.forEach(row => {
            if (!row.ecGoods || row.ecGoods.linkProductId === null) {
              unlinkedProductNumbers.push(row.receiveOrderRowGoodsId)
            }
          })
        }
      })
      // 未連携の商品が一つでもあればエラーメッセージを表示して処理を中断
      if (unlinkedProductNumbers.length > 0) {
        // 重複する商品番号を削除して表示を整形
        const uniqueProductNumbers = [...new Set(unlinkedProductNumbers)]
        const errorMessage = `以下の商品が未連携のため登録できません。\nEC商品番号: ${uniqueProductNumbers.join(', ')}`
        alert(errorMessage)
        return
      }
      this.setIsLoading(true)
      try {
        // 1. 選択された各伝票に対してAPI呼び出しのプロミスを作成する
        const promises = this.selectedEcReceiveOrderIds.map((item) => {
          const formatData = {
            ecReceiveOrderId: item.ecReceiveOrderId,
            customerId: this.inputData.customer.value,
            currencyId: this.inputData.currency.value,
            isAutoShip: this.inputData.autoShipFlg
          }
          return this.registerSaleFromEcReceiveorderFromApi(formatData).then(
            (success) => ({
              success,
              ecReceiveOrderId: item.ecReceiveOrderId
            })
          )
        })

        // 2. Promise.allSettledですべてのAPI呼び出しが完了するのを待つ
        const results = await Promise.allSettled(promises)

        // 3. 成功した伝票のIDを収集
        const successfulOrderIds = results
          .filter(
            (result) =>
              result.status === 'fulfilled' && result.value.success === true
          )
          .map((result) => result.value.ecReceiveOrderId)

        // 4. 親コンポーネントに成功したIDを通知
        if (successfulOrderIds.length > 0) {
          this.$emit('registration-successful', successfulOrderIds)
        }

        const successCount = successfulOrderIds.length
        const failureCount =
          this.selectedEcReceiveOrderIds.length - successCount

        if (failureCount === 0) {
          alert(
            'すべての伝票の登録が完了しました。\n※販売ステータスの更新には数分程度かかる場合があります。'
          )
        } else {
          alert(
            `登録処理が完了しました。\n成功: ${successCount}件\n失敗: ${failureCount}件\n※販売ステータスの更新には数分程度かかる場合があります。`
          )
        }
        // this.closeDialog() // 親コンポーネントがイベントを受け取ってから閉じるようにするため、コメントアウト
      } catch (error) {
        console.error('登録処理中にエラーが発生しました:', error)
        alert('登録処理中に予期せぬエラーが発生しました。')
      } finally {
        this.setIsLoading(false)
      }
    },
    closeDialog() {
      this.$emit('input', false)
    }
  },
  computed: {
    formItems() {
      const baseItems = [
        {
          name: 'customer',
          text: 'nextengine.nextengine_ec-receiveorder-customer-shop',
          component: 'SelectCustomerNameForNextengine',
          required: true
        },
        {
          name: 'currency',
          text: 'common.input_currency',
          component: 'SelectCurrency',
          required: true
        }
      ]
      // 顧客が選択されており、かつ自動出庫倉庫IDが設定されている場合のみ表示
      if (
        this.inputData.customer &&
        this.inputData.customer.autoShipStorageId !== null
      ) {
        baseItems.push({
          name: 'autoShipFlg',
          text: 'nextengine.nextengine_auto-ship',
          component: 'CheckAutoShip'
        })
      }
      return baseItems
    },
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    processedEcReceiveorderLists() {
      if (!this.ecReceiveorderLists) {
        return []
      }
      return this.ecReceiveorderLists.map(order => {
        let isFullyLinked = true
        if (order.ecReceiveOrderRows && order.ecReceiveOrderRows.length > 0) {
          isFullyLinked = order.ecReceiveOrderRows.every(
            row => row.ecGoods && row.ecGoods.linkProductId !== null
          )
        }

        return {
          ...order,
          isFullyLinked: isFullyLinked, // 判定用のフラグ
          linkedStatusText: isFullyLinked ? '連携済み' : '一部未連携' // 表示用の文言
        }
      })
    }
  },
  watch: {
    'inputData.customer': {
      handler(newCustomer) {
        // 自動出庫倉庫が設定されていない顧客が選択された場合、自動出庫フラグをリセット
        if (!newCustomer || newCustomer.autoShipStorageId === null) {
          this.inputData.autoShipFlg = false
        }
      },
      deep: true
    },
    inputValue: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.init()
        } else {
          this.selectedEcReceiveOrderIds = []
        }
      }
    },
    ecReceiveorderLists: {
      deep: true,
      handler(newVal) { if (newVal) this.init() }
    },
    selectedEcReceiveOrderIds(newSelection, oldSelection) {
      // 項目が追加された時のみチェック
      if (newSelection.length > oldSelection.length) {
        // 追加された項目を特定
        const newlySelectedItem = newSelection.find(
          (item) =>
            !oldSelection.some(
              (oldItem) => oldItem.ecReceiveOrderId === item.ecReceiveOrderId
            )
        )

        // 追加された項目が「一部未連携」の場合
        if (newlySelectedItem && !newlySelectedItem.isFullyLinked) {
          alert('選択した受注伝票はEC販売商品とSpes商品を未連携のため選択できません。')
          // v-modelの更新がDOMに反映された後に、選択状態を元に戻す
          this.$nextTick(() => {
            this.selectedEcReceiveOrderIds = oldSelection
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.section-title {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.info-col {
  padding: 0;
  &:not(:last-child) {
    border-right: 1px solid #d8d8d8;
  }
}

.info-display-table {
  th {
    font-size: 0.9rem;
    font-weight: bold;
    background-color: rgba(151, 198, 234, 0.1);
    text-align: left;
    padding: 8px 16px !important;
  }
  .label-cell {
    width: 35%;
    color: #616161;
    font-size: 0.875rem;
    padding: 4px 8px !important;
    height: 28px !important;
    border-bottom: none !important;
  }
  .value-cell {
    font-size: 0.875rem;
    padding: 4px 8px !important;
    height: 28px !important;
    word-break: break-all;
    border-bottom: none !important;
  }
  tr:last-child {
    td {
      border-bottom: none;
    }
  }
}

.summary-area {
  background-color: #f5f5f5;
}

.summary-item {
  color: #616161;
  font-size: 0.875rem;
  padding-top: 4px;
  padding-bottom: 4px;
}

.total-amount {
  font-size: 1rem;
  font-weight: bold;

  .amount {
    font-size: 1.75rem;
    margin: 0 4px 0 16px;
  }
}

.order-detail-table {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    font-weight: bold;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table td {
    border-collapse: collapse;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
    vertical-align: middle;
    padding: 16px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee !important;
  }
}
</style>
